import {
  putLanguageData,
  postSettingsData
} from 'src/services/apiRequests/LanguageService';
import { LanguageContent } from 'src/services/responseTypes/singleLaunchResponse';
import {
  getLocalStorage,
  setLocalStorage
} from 'src/utils/browserStorageHandler';
import { UserTypes } from 'src/utils/constants/stringConstants';
import { ContentLangugaBannerEnums } from 'src/utils/constants/utilConstants';

import { LANGUAGE_LABELS } from '../../utils/languageConstants';

const { SESSION_VALUE, SESSION_VALUE_FOR_LOGGED_IN } =
  ContentLangugaBannerEnums;

/**
 * return the combined string of languages
 * @param languages array of languages
 * @returns combined string
 */
const formatString = (languages: string[]) => {
  const length = languages.length;
  if (length === 0) return LANGUAGE_LABELS.en.en;
  if (length === 1) return languages[0];
  return `${languages.slice(0, length - 1).join(', ')} & ${
    languages[length - 1]
  }`;
};

const contentLanguageEqualityFilter =
  (usersContentLanguages: string[]) => (language: LanguageContent) =>
    usersContentLanguages.find((userLang) => userLang === language.l_code);

export const getContentLanguageBannerText = (
  displayLanguage: string,
  userContentLanguages: string,
  contentLanguages: LanguageContent[]
) => {
  const userContentLanguagesArray = userContentLanguages.split(',');
  const languageTranslationInDisplayLanguage =
    LANGUAGE_LABELS?.[displayLanguage as keyof typeof LANGUAGE_LABELS];

  const availableContentLanguages = contentLanguages.filter(
    contentLanguageEqualityFilter(userContentLanguagesArray)
  );

  //returns the content languges in display language text
  const contentLanguagesInDisplayLanguage = availableContentLanguages.map(
    (language) =>
      languageTranslationInDisplayLanguage?.[
        language?.l_code as keyof typeof languageTranslationInDisplayLanguage
      ]
  );
  return formatString(contentLanguagesInDisplayLanguage);
};

export const getGuestVisibilityCount = () => {
  const viewCounts = parseInt(getLocalStorage(SESSION_VALUE)) || 0;
  if (!viewCounts) {
    setLocalStorage(SESSION_VALUE, 0);
    return 0;
  }
  return viewCounts;
};

export const viewCountHandler = (userType: string, token: string) => {
  let viewCounts = 0;
  let isPostCalled = false;
  if (userType === UserTypes.GUEST) {
    viewCounts = getGuestVisibilityCount();
  } else {
    const data = getRegisteredVisibilityCount(token);
    viewCounts = data.viewCounts;
    isPostCalled = data.isPostCalled;
  }
  return {
    viewCounts,
    isPostCalled
  };
};

export const postSettingDataHandler = (
  isPostCalled: boolean,
  viewCounts: number,
  token: string,
  VISBILITY_COUNT: string
) => {
  if (token && !isPostCalled) {
    postSettingsData(VISBILITY_COUNT, `${viewCounts + 1}`);
  }
};

export const setRegisteredUserVisibilityCount = (
  count: number,
  token?: string
) => {
  if (token) {
    putLanguageData(ContentLangugaBannerEnums.VISBILITY_COUNT, `${count}`);
  }
  setLocalStorage(SESSION_VALUE_FOR_LOGGED_IN, count);
};

export const setGuestUserVisibilityCount = (count: number) => {
  setLocalStorage(SESSION_VALUE, count);
};

export const getRegisteredVisibilityCount = (token?: string) => {
  let isPostCalled = false;
  const viewCounts =
    parseInt(getLocalStorage(SESSION_VALUE_FOR_LOGGED_IN)) || 0;

  if (!viewCounts) {
    if (token) {
      postSettingsData(ContentLangugaBannerEnums.VISBILITY_COUNT, '1');
      isPostCalled = true;
    }
    setLocalStorage(SESSION_VALUE_FOR_LOGGED_IN, 1);
    return { viewCounts: 1, isPostCalled };
  }
  return { viewCounts, isPostCalled };
};
